// Slider Script
document.addEventListener('DOMContentLoaded', function() {
  const slides = document.querySelectorAll('.slide');
  let currentSlide = 3; // Start with slide 4 (index 3) which has "active" class
  
  function showSlide(index) {
    slides.forEach((slide, i) => {
      slide.classList.remove('active');
      if (i === index) {
        slide.classList.add('active');
      }
    });
  }
  
  function nextSlide() {
    currentSlide = (currentSlide + 1) % slides.length;
    showSlide(currentSlide);
  }
  
  function prevSlide() {
    currentSlide = (currentSlide - 1 + slides.length) % slides.length;
    showSlide(currentSlide);
  }
  
  // Auto-advance slides every 4 seconds
  setInterval(nextSlide, 4000);
  
  // Click to advance manually
  slides.forEach((slide, index) => {
    slide.addEventListener('click', function() {
      currentSlide = index;
      showSlide(currentSlide);
    });
  });
});